import {FalSecurityModel, OrganizationModel  } from './';


export class CompanySecurityOfficerModel {
  companySecurityOfficerId: number;
  organizationId: number;
  givenName: string;
  surname: string;
  phoneNumber: string;
  email: string;
  // Models
  organization: OrganizationModel;
  falSecurity: FalSecurityModel[];
}



// WEBPACK FOOTER //
// ./src/app/shared/models/company-security-officer-model.ts